import axios from "axios";
import { EncryptStorage } from "encrypt-storage";

const fetchApi = (type = "") => {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const baseURL = process.env.REACT_APP_SERVICE;

  // Get Token
  const userInfo = encryptStorage.getItem("___info");
  const accessToken = userInfo?.token || "";

  const api = axios.create({
    baseURL: baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Access-Control-Allow-Origin": true,
      "Access-Control-Allow-Credentials": true,
      "Accept-Language": "en",
    },
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (type === "auth") {
        return Promise.reject(error);
      } else {
        if (error?.response?.status === 403) {
          //Token Habis
          encryptStorage.clear();
          localStorage.clear();
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    }
  );

  return api;
};

const fetchApiRotate = (type = "") => {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const baseURL = 'https://facereco.grit.id:9022/'

  // Get Token
  const userInfo = encryptStorage.getItem("___info");
  const accessToken = userInfo?.token || "";

  const api = axios.create({
    baseURL: baseURL,
    headers: {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": true,
      "Access-Control-Allow-Credentials": true,
      "Accept-Language": "en",
    },
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (type === "auth") {
        return Promise.reject(error);
      } else {
        if (error?.response?.status === 403) {
          //Token Habis
          encryptStorage.clear();
          localStorage.clear();
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    }
  );

  return api;
};

const fetchApiResponseVideo = (type = "") => {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const baseURL = "https://facereco.grit.id:9004/";
  const customFetch = async (endpoint, options = {}) => {
    const url = baseURL + endpoint;
    const defaultHeaders = {
      "Accept-Language": "en",
    };

    options.headers = {
      ...defaultHeaders,
      ...(options.headers || {}),
    };

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        if (type !== "auth" && response.status === 403) {
          encryptStorage.clear();
          localStorage.clear();
          window.location.href = "/login";
        }
        const errorData = await response.json().catch(() => ({}));
        return Promise.reject(errorData || "An error occurred");
      }
      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return customFetch;
};

export { fetchApi, fetchApiResponseVideo, fetchApiRotate };
